import { Injectable, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs';
import { createSymbol } from '../../utils/symbol';
import { RenderingContext } from './../../../api';
import { ComponentTypeRef } from './../../../ng-api';

export type MarkupGenerator = (
  context: RenderingContext,
  options?: any
) => string;

export interface MarkupProvider {
  compile(aURL: string, aTemplateString: string): Observable<MarkupGenerator>;
  getComponentTypeRef(): ComponentTypeRef<any>;
}

export interface MarkupProviders {
  [layoutType: string]: MarkupProvider;
}

const KEY_PROVIDERS = createSymbol();

@Injectable({ providedIn: 'root' })
export class MarkupService implements OnDestroy {
  constructor() {
    this[KEY_PROVIDERS] = {};
  }

  get markupProviders(): MarkupProviders {
    return this[KEY_PROVIDERS] as MarkupProviders;
  }

  registerProvider(aLayoutType: string, aProvider: MarkupProvider) {
    // register the provider
    this[KEY_PROVIDERS][aLayoutType] = aProvider;
  }

  /*
     * Potentially called when the service falls out of scope
     */
  ngOnDestroy(): void {}
}
